import * as types from '../const/action.types';

export function termometre(state = {}, action) {
    switch (action.type) {
        case types.LOAD_TERMOMETRE_SUCCESS:
            console.log(action.data);
            return action.data;
        default:
            return state;
    }
}

export function termometresFields(state = [], action) {
    switch (action.type) {
        case types.LOAD_TERMOMETRE_FIELDS_SUCCESS:
            console.log(action.data);
            return action.data;
        default:
            return state;
    }
}

export function termometres(state = [], action) {
    switch (action.type) {
        case types.TERMOMETRES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function termometresHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.TERMOMETRES_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function termometresIsLoading(state = false, action) {
    switch (action.type) {
        case types.TERMOMETRES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/termometre.reducer.js